import { useState, useEffect } from 'react';

import { formatSecondsToHHMMSS, getSessionLabel } from '@/lib/utils';

const SESSION_LABEL = getSessionLabel();

export function useCountdown(remainingSeconds: Readonly<number>) {
  const [countdown, setCountdown] = useState('');
  const [timeLeft, setTimeLeft] = useState(remainingSeconds);

  useEffect(() => {
    setTimeLeft(remainingSeconds);
  }, [remainingSeconds]);

  useEffect(() => {
    const updateCountdown = () => {
      setTimeLeft(prevTime => {
        if (prevTime > 0) {
          const newTime = prevTime - 1;
          const days = Math.floor(newTime / (60 * 60 * 24));

          if (days > 0) {
            if (days === 1) {
              setCountdown(`${days} day`);
            } else {
              setCountdown(`${days} days`);
            }
          } else {
            setCountdown(formatSecondsToHHMMSS(newTime));
          }

          return newTime;
        } else {
          setCountdown(`${SESSION_LABEL.capitalize} Started`);
          return 0;
        }
      });
    };

    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  const resetCountdown = () => {
    setTimeLeft(remainingSeconds);
  };

  return { countdown, timeLeft, resetCountdown };
}
